import _ from "lodash";
import axios from "axios";

import { sisikong_url } from "../api";

export async function searchRequestTransfers({ params }: { params: any }) {
  try {
    const response = await axios.get(`${sisikong_url}/transfer/initiate-search/`, {
      params,
    });
    return response?.data ?? {};
  } catch {}

  return null;
}

export async function searchRequestTransfersPOST({
  payload,
  onError,
}: { payload: any; onError: () => void }) {
  try {
    const response = await axios.post(`${sisikong_url}/transfer/initiate-search/`, payload);
    return response?.data ?? {};
  } catch {
    onError();
  }
  return null;
}

export async function pollTransfersSearch({
  session_id,
  onError,
}: { session_id: string; onError: (error: any) => void }) {
  try {
    const response = await axios.get(`${sisikong_url}/transfer/poll/${session_id}`);
    return response?.data ?? {};
  } catch (error) {
    return onError(error);
  }
}

export async function fetchSavedTransferSearchResults({
  search_session_id,
}: { search_session_id: string }) {
  try {
    const response = await axios.get(`${sisikong_url}/transferengine/search/${search_session_id}`);

    return response.data;
  } catch {
    return null;
  }
}

export async function transferPreBook({ data }: { data: any }) {
  try {
    const response = await axios.post(`${sisikong_url}/transferengine/pre-book/`, { ...data });
    return response?.data ?? {};
  } catch {}
  return null;
}

export async function createTransferBooking({ payload }: { payload: any }) {
  try {
    const response = await axios.post(`${sisikong_url}/transferengine/book/`, payload);
    return response?.data ?? {};
  } catch {}
  return null;
}
